// extracted by mini-css-extract-plugin
module.exports = {"icon":"ThankYouStep_icon__15yfC","title":"ThankYouStep_title__2CmQv","subtitle":"ThankYouStep_subtitle__Qosr7"};